import Hero from '../Components/Screens/Hero';
import SimpleImageBanner from '../Components/Custom/Banners/SimpleImageBanner';
import ContactTable from '../Components/Custom/ContactTable';
import MissionStatement from '../Components/Custom/MissionStatement';
import CardFeatures from '../Components/Custom/CardFeatures';
import {
  IconWithTextList,
  InterestRates,
  PCCardSpecList,
  Information,
} from '../Components/Custom/TitleImageWithIconList';
import LegalDetails from '../Components/Custom/LegalDetails';
import MobileCarouselBanner from '../Components/Custom/Banners/MobileCarouselBanner';
import { ProductCards } from '../Components/Custom/Card-Sections/ProductCards';
import FAQBlock from '../Components/Custom/FAQ/FAQBlock';
import DigitalProductBlock from '../Components/Custom/DigitalProduct/DigitialProductBlock';
import { BlogCards } from '../Components/Custom/Card-Sections/BlogCards';
import OptimumStoresBanner from '../Components/Custom/Optimum/OptimumStoresBanner';
import FAQSections from '../Components/Custom/FAQ/FAQSections';
import { FeatureCards, Products } from '../Components/Custom/Card-Sections';
import SectionContainer from '../Components/Custom/SectionContainer';
import VideoPopularSection from '../Components/Custom/Video/VideoPopularSection';
import OptimumProductCards from '../Components/Custom/Optimum/OptimumProductCards';
import ProTip from '../Components/Custom/ProTip';
import ProductDetails from '../Components/Custom/ProductDetails';
import Chart from '../Components/Custom/Chart';
import CalculatorSingular from '../Components/Custom/CalculatorSingular';
import DigitalProductBanner from '../Components/Custom/DigitalProduct/DigitalProductBanner';
import PCSignatureBanner from '../Components/Custom/Banners/PCSignatureBanner';
import SimpleCTABanner from '../Components/Custom/Banners/SimpleCTABanner';
import CDICScreen from '../Components/Screens/CDIC/CDICScreen';
import Paragraph from '../Components/Custom/Paragraph';
import FAQSearchSection from '../Components/Custom/FAQ/FAQSearchSection';
import CompanyUpdates from '../Components/Custom/CompanyUpdates';
import FAQScreen from '../Components/Screens/FAQ/FAQScreen';
import PCOptimumHero from '../Components/Custom/Banners/PCOptimumHero';
import ContentCenter from '../Components/Custom/ContentCenter';
import LegalArticles from '../Components/Screens/LegalArticles';
import FeatureChecklist from '../Components/Custom/FeatureChecklist';
import FeatureTiles from '../Components/Custom/Cards/FeatureTiles';
import LongFeatureCards from '../Components/Custom/LongFeatureCards';
import JumpLinks from '../Components/Custom/JumpLinks';
import ProductDeviceStep from '../Components/Custom/ProductDeviceStep';
import StaticGallery from '../Components/Custom/Gallery/Static';
import TickerGallery from '../Components/Custom/Gallery/Ticker';
import CarouselGallery from '../Components/Custom/Gallery/Carousel';
import {
  AccordionSection,
  OverflowCarousel,
  SlideCarousel,
  PCMACarousel,
  OfferDetails,
  PointsSectionChart,
  SpecialOffersContainer,
  Spotlight,
  FeatureCarousel,
  RatingAndTestimonialSection,
  FeatureSection,
} from '../Components/Custom/Sections';
import {
  DigitalBankBanner,
  SpecialOffersBanner,
} from '../Components/Custom/AppBanner';
import StaticSplitWidthHeroBanner from '../Components/Custom/Banners/StaticSplitWidth';
import OfferBannerHero from '../Components/Custom/Banners/OfferBannerHero';
import PCMASplitWidthContainer from '../Components/Custom/PCMASplitWidthContainer';
import StaticHeroImageOverflow from '../Components/Custom/Banners/StaticHeroImageOverflow';
import SavingCalculatorSection from '../Components/Custom/Sections/SavingCalculatorSection';
import { PointsTileCards } from '../Components/Custom/Card-Sections/PointsTiles';
import VideoTutorialVideoPlayer from '../Components/Custom/Video/VideoTutorialVideoPlayer';
import PresentationVideo from '../Components/Custom/Video/PresentationVideo';
import CarouselAndBannerSection from '../Components/Custom/Sections/CarouselAndBannerSection';
import ChecklistBanner from '../Components/Custom/Banners/ChecklistBanner';
import BleedBanner from '../Components/Custom/Banners/BleedBanner';
import { LinkImageBanner } from '../Components/Custom/Banners';
import OptimumPointRoller from '../Components/Custom/Optimum/OptimumPointRoller';
import AnimatedCreditCardsHero from '../Components/Custom/Animated/AnimatedCreditCardsHero';
import { CardCarousel } from '../Components/Custom/Card-Sections/CardCarousel';
import { ProductImageCards } from '../Components/Custom/Card-Sections/ProductImageCards';
import StatementSection from '../Components/Custom/StatementSection';
import RedemptionContainer from '../Components/Custom/Sections/RedemptionContainer';
import ImageBanner from '../Components/Custom/Banners/ImageBanner';
import HeroCarousel from '../Components/Custom/Sections/HeroCarousel';
import RatingBanner from '../Components/Custom/Banners/RatingBanner';
import AwardBanner from '../Components/Custom/Banners/AwardBanner';
import LogoBanner from '../Components/Custom/Banners/LogoBanner';
import ImageOnlyBanner from '../Components/Custom/Banners/ImageOnlyBanner';
import { BannerIconCards } from '../Components/Custom/Card-Sections/BannerIconCards';
import CardComparisonContainer from '../Components/Custom/Sections/CardComparisonContainer';

// RETIRED IMPORTS
// import DigitalProductStepper from '../Components/Custom/DigitalProduct/DigitalProductStepper';
// import PointsDayHeroBanner from '../Components/Custom/Banners/PointsDay';
// import PCMASplitStatefulContainer from '../Components/Custom/PCMASplitStatefulContainer';
// import PersonalizationHero from '../Components/Custom/Banners/PersonalizationHero';
// import TeaserBanner from '../Components/Custom/Banners/TeaserBanner';
// import TilesSection from '../Components/Custom/TilesSection';
// import AnimatedFeatureBlocks from '../Components/Custom/Animated/AnimatedFeatureBlocks';
// import FeatureBlockSection from '../Components/Custom/FeatureBlockSection';
// import PCMAPointsBlock from '../Components/Custom/Card-Sections/PCMAPointsBlock';
// import SecurityBanner from '../Components/Custom/SecurityBanner';
// import PCMAPhoneBanner from '../Components/Custom/PCMAPhoneBanner';
// import {
//   PCMAHero,
//   PCMAHeroStatic,
// } from '../Components/Custom/Banners/PCMAHero';
// import LargeSlidingImage from '../Components/Custom/LargeSlidingImage';
// import AnimatedMultiProductHero from '../Components/Custom/Animated/AnimatedMultiProductHero';
// import AnimatedSlidingCoverHero from '../Components/Custom/Animated/AnimatedSlidingCoverHero';
// import Calculator from '../Components/Custom/Calculator';

export const heroBanner = {
  'hero-variation-3': Hero,
  'hero-variation-5': Hero,
  'hero-with-optimum-half-circles': Hero,
  'pc-optimum-hero': PCOptimumHero,
  'pcma-hero': StaticSplitWidthHeroBanner,
  'static-split-width-content': StaticSplitWidthHeroBanner,
  'static-404': Hero,
  'static-cdic': CDICScreen,
  'static-digital-banking': Hero,
  'static-digital-banking-overview': Hero,
  'static-hero-image-overflow': StaticHeroImageOverflow,
  'static-full-width-content': Hero,
  'static-offer-expired': Hero,
  'static-with-background-overflow': Hero,
  'offer-banner-hero': OfferBannerHero,
  'animated-stacked-cards': AnimatedCreditCardsHero,
  /**
   * ! Retired hero banners, variations archived and removed from Contentful list.
   */
  // 'points-day': PointsDayHeroBanner,
  // 'static-personalization': PersonalizationHero,
  // 'teaser-banner': TeaserBanner,
  // 'animated-fanned-cards': AnimatedMainProductHero,
  // 'hero-holiday-gradient': GradientAdventCalendarHero,
  // 'animated-fanned-cards-multi-product-holiday': AdventCalendarHero,
  // 'esso-campaign-hero': EssoCampaignHero,
  // 'hero-animated-campaign-email': AnimatedCampaignEmailHero,
  // 'hero-variation-campaign-content-right': Hero,
  // 'hero-with-optimum-circles': Hero,
  // 'phx-launch-campaign': Hero,
  // 'animated-fanned-cards-multi-product': AnimatedMultiProductHero,
  // 'animated-large-sliding-card': LargeSlidingImage,
  // 'animated-sliding-cover': AnimatedSlidingCoverHero,
  // 'pcma-confetti-video': PCMAHero,
  // 'pcma-confetti-video-static': PCMAHeroStatic,
};

export const simpleBanner = {
  'app-banner': SimpleImageBanner,
  'simple-image-banner': SimpleImageBanner,
  'digital-banking-banner': SimpleImageBanner,
  'pc-signature-banner': PCSignatureBanner,
  'hiring-banner': SimpleCTABanner,
  'checklist-banner': ChecklistBanner,
  'bleed-banner': BleedBanner,
  'image-banner': ImageBanner,
  'award-banner': AwardBanner,
  'logo-banner': LogoBanner,
  'image-only-banner': ImageOnlyBanner,
  // 'app-banner-image-right': SimpleImageBanner,
  // 'pcma-banner': SimpleImageBanner,
};

export const contactTable = {
  'contact-table': ContactTable,
};

export const statementSection = {
  'mission-statement': MissionStatement,
  'title-with-statement': MissionStatement,
  'page-introduction': MissionStatement,
  'security-statement': MissionStatement,
  'statement-section': StatementSection,
  // 'title-with-statement-grey-bkg': MissionStatement,
  // 'covid19-enrollment': MissionStatement,
  // 'red-velvet-gradient': MissionStatement,
  // 'red-velvet-gradient-small': MissionStatement,
};

export const titleOrImageWithIconLists = {
  'card-features': CardFeatures,
  'pcf-product-block': PCCardSpecList,
  'interest-rates': InterestRates,
  information: Information,
  'interest-rates-no-image': PCCardSpecList,
  'icon-with-text-list': IconWithTextList,
};

export const legal = {
  'legal-details': LegalDetails,
};

export const faqBlock = {
  'text-link-section': FAQBlock,
  'pcma-faq-section': FAQBlock,
};

export const appBanner = {
  'app-banner': DigitalProductBlock,
  'app-banner-image-center': DigitalProductBlock,
  'app-banner-section': DigitalProductBlock,
  'digital-bank-banner': DigitalBankBanner,
  'digital-app-banner': DigitalProductBanner,
  'digital-product-banner': DigitalProductBanner,
  'special-offers': SpecialOffersBanner,
  'link-image-banner': LinkImageBanner,
  'rating-banner': RatingBanner,
};

export const blogCards = {
  'blog-section': BlogCards,
};

export const faqPopularQuestion = {
  'faq-popular-questions': FAQSections,
  'related-faqs': FAQSections,
};

export const containerSection = {
  'app-banner-section': SectionContainer,
  'app-banner-video-section': SectionContainer,
  'anchor-wrapper': SectionContainer,
  'feature-checklist': FeatureChecklist,
  'offer-section': FeatureTiles,
  'security-statement': MissionStatement,
  'pcma-feature-blocks': LongFeatureCards,
  'anchor-links': JumpLinks,
  'card-steps-section': FeatureTiles,
  'claims-rewards-section': LongFeatureCards,
  'accordion-section': AccordionSection,
  'overflow-carousel': OverflowCarousel,
  'popular-videos': VideoPopularSection,
  'product-block': ProductCards,
  'product-step': MobileCarouselBanner,
  'product-device-step-section': ProductDeviceStep,
  'optimum-product-block': OptimumProductCards,
  'product-step-block': MobileCarouselBanner,
  'pcma-list-section': PCMASplitWidthContainer,
  'feature-block': FeatureCards,
  'feature-block-show-more': FeatureCards,
  'pavilion-cleanliness': FeatureCards,
  'slide-carousel': SlideCarousel,
  'pcma-product-step': PCMACarousel,
  'points-reward-section': FeatureTiles,
  'offer-details': OfferDetails,
  'points-section-chart': PointsSectionChart,
  'savings-calculator': SavingCalculatorSection,
  'points-feature-section': PointsTileCards,
  'carousel-and-banner-section': CarouselAndBannerSection,
  'special-offer-container': SpecialOffersContainer,
  carousel: CardCarousel,
  'product-section': Products,
  'product-image-section': ProductImageCards,
  'spotlight-section': Spotlight,
  'feature-carousel': FeatureCarousel,
  'testimonial-rating-section': RatingAndTestimonialSection,
  'hero-carousel': HeroCarousel,
  'feature-section': FeatureSection,
  'banner-icon-card-section': BannerIconCards,
  'redemption-cards-section': RedemptionContainer,
  'comparison-card-section': CardComparisonContainer,

  // RETIRED SECTION CONTAINERS
  // 'pcma-stateful-split-width': PCMASplitStatefulContainer,
  // 'gradient-introduction-section': GradientIntroSection,
  // 'product-step-red': MobileCarouselBanner,
  // 'product-step-velvet': MobileCarouselBanner,
  // 'product-step-red': MobileCarouselBanner,
  // 'product-step-velvet': MobileCarouselBanner,
  // 'product-bubble-section': PCMAPointsBlock,
  // 'feature-tile': TilesSection,
  // 'pcma-points-block': PCMAPointsBlock,
  // 'animated-feature-tile': AnimatedFeatureBlocks,
  // 'covid19-feature-block': FeatureBlockSection,
  // 'pco-earn-section': SectionContainer,
  // 'earn-optimum-points': OptimumPointCircleBanner,
};

export const proTip = {
  'pro-tip': ProTip,
};

export const productDetails = {
  'product-details': ProductDetails,
};

export const optimumPointRoller = {
  'optimum-points-roller': OptimumPointRoller,
};

export const optimumStoresBanner = {
  'pc-optimum-store-banner': OptimumStoresBanner,
  'pc-optimum-store-accordion': OptimumStoresBanner,
};

export const chart = {
  chart: Chart,
  'selectable-card chart': Chart,
  'selectable-card chart v2': Chart,
  'row-layout-chart': Chart,
  'column-layout-chart': Chart,
  'pcma-chart': Chart,
  'single-table': Chart,
};

export const calculator = {
  // calculator: Calculator,
  'calculator-singular': CalculatorSingular,
};

export const gallery = {
  gallery: StaticGallery,
  'gallery-ticker': TickerGallery,
  'gallery-carousel': CarouselGallery,
};

export const paragraph = {
  'simple-paragraph': Paragraph,
  articles: CompanyUpdates,
  'security-paragraph': Paragraph,
  'legal-stuff-paragraph': Paragraph,
};

export const searchSection = {
  'faq-search-section': FAQSearchSection,
};

export const faqSection = {
  'faq-section': FAQScreen,
};

export const mediaCentre = {
  'media-centre': ContentCenter,
};

export const legalArticle = {
  'legal-stuff-section': LegalArticles,
};

// export const stepper = {
//   'app-banner-stepper': DigitalProductStepper,
// };

export const videos = {
  'video-item': VideoTutorialVideoPlayer,
  'presentation-video': PresentationVideo,
};
